import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { customTheme } from "./utils/Themes";
import { useEffect } from "react";
import Home from "./pages/Home";
import { PageError } from "./pages/PageError";
import Layout from "./templates/Layout";
import Event from "./pages/Event";
import LoginPage from "./pages/LoginPage";
import Gallery from "./pages/Gallery";
import Article from "./pages/Article";
import ManageAdmin from "./pages/ManageAdmin";
import Settings from "./pages/Settings";
import ToastProvider from "./components/context/ToastContext";
import { UserProvider } from "./components/context/UserContext";
import CreateEvent from "./components/Event/CreateEvent";
import CreateGallery from "./components/Gallery/CreateGallery";
import UpdateGallery from "./components/Gallery/UpdateGallery";
import { UpdateEvent } from "./components/Event/UpdateEvent";
import CreateAdmin from "./components/ManageAdmin/CreateAdmin";
import CreateArticle from "./components/Article/CreateArticle";
import UpdateArticle from "./components/Article/UpdateArticle";
import Notification from "./pages/Notification";
import Author from "./pages/Author";
import CreateAuthor from "./components/Author/CreateAuthor";
import UpdateAuthor from "./components/Author/UpdateAuthor";
import Members from "./pages/Members";
import CreateMember from "./components/Members/CreateMember";
import UpdateMember from "./components/Members/UpdateMember";
import SbcTracts from "./pages/SbcTracts";
import CreateTract from "./components/Tracts/CreateTract";
import UpdateTract from "./components/Tracts/UpdateTract";
import Birthdays from "./pages/Birthdays";
import BirthdayMonths from "./pages/BirthdayMonths";

function App() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="App selection:bg-custom selection:text-white">
      <ThemeProvider theme={customTheme}>
        <Router>
          <UserProvider>
          <Routes>
            <Route
              path="/"
              element={
                <ToastProvider>
                  <LoginPage />
                </ToastProvider>
              }
            />

            <Route
              path="/home"
              element={
                <ToastProvider>
                  <Layout>
                    <Home />
                  </Layout>
                </ToastProvider>
              }
            />

            {/* Events */}
            <Route path="/event" element={<Layout><Event /></Layout>} />
            <Route path="/create-event" element={<Layout><CreateEvent /></Layout>} />
            <Route path="/update-event/:id" element={<Layout><UpdateEvent /></Layout>} />

            {/* Articles */}
            <Route path="/article" element={<Layout><Article /></Layout>} />
            <Route path="/create-article" element={<Layout><CreateArticle /></Layout>} />
            <Route path="/update-article/:id" element={<Layout><UpdateArticle /></Layout>} />

            {/* Gallery */}
            <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
            <Route path="/create-gallery" element={<Layout><CreateGallery /></Layout>} />
            <Route path="/update-gallery/:id" element={<Layout><UpdateGallery /></Layout>} />

            {/* Authors */}
            <Route path="/author" element={<Layout><Author /></Layout>} />
            <Route path="/create-author" element={<Layout><CreateAuthor /></Layout>} />
            <Route path="/update-author/:id" element={<Layout><UpdateAuthor /></Layout>} />

            {/* Members */}
            <Route path="/members" element={<Layout><Members /></Layout>} />
            <Route path="/create-member" element={<Layout><CreateMember /></Layout>} />
            <Route path="/update-member/:id" element={<Layout><UpdateMember /></Layout>} />

            {/* Birthdays */}
            <Route path="/birthdays" element={<Layout><BirthdayMonths /></Layout>} />
            <Route path="/birthdays/:monthIndex" element={<Layout><Birthdays /></Layout>} />

            {/* SBC Tracts */}
            <Route path="/sbc-tracts" element={<Layout><SbcTracts /></Layout>} />
            <Route path="/create-tract" element={<Layout><CreateTract /></Layout>} />
            <Route path="/update-tract/:id" element={<Layout><UpdateTract /></Layout>} />

            {/* Admin */}
            <Route path="/manage-admin" element={<Layout><ManageAdmin /></Layout>} />
            <Route path="/create-admin" element={<Layout><CreateAdmin /></Layout>} />
            <Route path="/update-admin" element={<Layout><ManageAdmin /></Layout>} />
            <Route path="/notification" element={<Layout><Notification /></Layout>} />
            <Route path="/settings" element={<Layout><Settings /></Layout>} />

            <Route path="*" element={<PageError />} />
          </Routes>
          </UserProvider>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
